import React, { useState, useEffect } from 'react';
import styles from './App.scss';
import Header from './components/Header';
import Aside from './components/Aside';
import AboutUs from './components/AboutUs';
import ProductsAndServices from './components/ProductsAndServices';
import OurTeam from './components/OurTeam';
import Partner from './components/Partner';
import OurTrend from './components/OurTrend';
import ContactUs from './components/ContactUs';

const resizeListener = () => {
  let html = document.documentElement;

  let designSize1 = 1920;
  let clientW = html.clientWidth;
  let htmlRem1 = clientW / designSize1;

  let designSize2 = 946;
  let clientH = html.clientHeight;
  let htmlRem2 = clientH / designSize2;

  html.style.fontSize = 100 * Math.min(htmlRem1, htmlRem2) + 'px';
}

function App() {
  useEffect(() => {
    window.addEventListener('resize', resizeListener);
    resizeListener();
    return () => window.removeEventListener('resize', resizeListener);
  }, []);

  const [curPanel, setCurPanel] = useState(() => {
    const initPanel = window.location.href.split('?initPanel=')[1];
    if (initPanel) {
      const url = window.location.href.split('?initPanel=')[0];
      setTimeout(() => {
        history.replaceState({ url }, document.title, url);
      }, 0);
    }

    return initPanel || 'aboutUs';
  });
  const [asideStyle, setAsideStyle] = useState({ backgroundColor: '#DCDDEB', theme: 'black' });
  const [headerStyle, setHeaderStyle] = useState({});

  const renderPanel = () => {
    return (
      <>
        <AboutUs setAsideStyle={setAsideStyle} setHeaderStyle={setHeaderStyle} asideStyle={asideStyle} curPanel={curPanel} />;
        <ProductsAndServices setAsideStyle={setAsideStyle} setHeaderStyle={setHeaderStyle} asideStyle={asideStyle} curPanel={curPanel} />;
        <OurTeam setAsideStyle={setAsideStyle} setHeaderStyle={setHeaderStyle} asideStyle={asideStyle} curPanel={curPanel} />;
        <Partner setAsideStyle={setAsideStyle} setHeaderStyle={setHeaderStyle} asideStyle={asideStyle} curPanel={curPanel} />;
        <OurTrend setAsideStyle={setAsideStyle} setHeaderStyle={setHeaderStyle} asideStyle={asideStyle} curPanel={curPanel} />;
        <ContactUs setAsideStyle={setAsideStyle} setHeaderStyle={setHeaderStyle} asideStyle={asideStyle} curPanel={curPanel} />;
      </>
    )
  }

  return (
    <div className={styles.App}>
      <Aside
        curPanel={curPanel}
        asideStyle={asideStyle}
      />

      <div className={styles.main}>
        <Header
          curPanel={curPanel}
          setCurPanel={setCurPanel}
          headerStyle={headerStyle}
          setAsideStyle={setAsideStyle}
          setHeaderStyle={setHeaderStyle}
        />

        <div className={styles.content}>
          {renderPanel()}
        </div>
      </div>
    </div>
  );
}

export default App;
